
import React from "react";

const EmptyEventsList = () => {
  return (
    <div className="text-center py-10">
      <p className="text-muted-foreground">No events found</p>
    </div>
  );
};

export default EmptyEventsList;
